// extracted by mini-css-extract-plugin
export default {"link":"link__Us0NmjpH","arrow":"arrow__NYk1swYn"};